import React, { Component } from 'react'
import styled, { withTheme } from 'styled-components';
import { message, Modal, Popconfirm, Tabs, Tag } from 'antd';
import { CardContainer, Flex, FlexColumn } from '../../Reusable/Container';
import { addressObjectToStr, formatPhoneNumber, getDateInLocalTZ, getResourcePerm, renderBankIcon, toCurrency } from '../../../Utils/util';
import PaymentMethodDetails from '../../Reusable/PaymentMethodDetails';
import { fetchBBHistory, normalizeAndSortHistory } from '../../../Utils/bankingDataManager';
import { apiPOSTReq } from '../../../Utils/api';
import environment from '../../../environment';
import { ErrorAlert } from '../../Reusable/Alert';
import PageHeader from '../../Reusable/PageHeader';
import { Text } from '../../Reusable/Text';
import LucideIcon, { Button, ImageButton, TextButton } from '../../Reusable/Button';

import Edit from '../../../Images/edit.svg'
import ModalClose from '../../../Images/modal-close.png'
import Delete from '../../../Images/delete-red-icon.png'
import { LabeledInput } from '../../Reusable/Input';
import TableView from '../../Reusable/TableView';
import PendingTable from '../../Banking/Reusable/PendingTable';
import DeactivateTransferMethod from '../../Banking/Recipients/DeactivateTransferMethod';
import AddPaymentMethod from './AddPaymentMethod';
import hexToRgba from 'hex-to-rgba';
import moment from 'moment';
import PaymentHistoryChart from './PaymentHistoryChart';
import FullScreenModal from '../../Reusable/FullScreenModal';
import AlertModal from '../../Reusable/AlertModal';
import NewBillFlow from '../Bills/New Bill/Index';
import { Image } from '../../Reusable/Image';
import RightArrow from '../../../Images/right-arrow.svg'
import { validate } from 'uuid';
import { SignedLink } from '../../Reusable/Link';
import { Eye, Trash } from 'lucide-react';
import DocumentUploadModal from './DocumentUploadModal';
import { connect } from 'react-redux';
import InboxTable from '../Bills/Inbox/InboxTable';
import BillTable from '../Bills/BillTable';

const { TabPane } = Tabs;

const ContainerBanner = styled.div`
    background: ${props => hexToRgba(props.theme.colors.primary2, 0.4)};
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    border-bottom: none;
    margin-bottom: -5px; // This pulls the table up to overlap
    position: relative; // Ensures proper stacking
    /* z-index: -1; // Places banner above the table */
`;

const TableWrapper = styled.div`
    position: relative;
`;

class VendorDetails extends Component {
    state = {
        pagination: {
            current: 1,
            pageSize: 100,
            showSizeChanger: false,
        },
        loading: false,
        selectedTab: 'details',
        transferMethods: [],
        vendor: this.props.location.state.vendor || {}
    }

    componentDidMount() {
        console.log("componentDidMount vendors")
        // Check for vendor in location state
        if (this.props.location && this.props.location.state) {
            let vendor;
            
            // First check for updatedVendor specifically
            if (this.props.location.state.updatedVendor) {
                vendor = this.props.location.state.updatedVendor;
                console.log("Using updatedVendor from location state", vendor);
            } 
            // Fall back to regular vendor if updatedVendor isn't available
            else if (this.props.location.state.vendor) {
                vendor = this.props.location.state.vendor;
                console.log("Using vendor from location state", vendor);
            }
            
            if (vendor) {
                const recipientId = vendor.associatedCPObjectId;
                this.setState({ vendor, recipientId });

                this.getPaymentMethods();
                this.getVendorCounterparty();

                // Fetch vendor from the DB if something changed with vendor stats etc. based on user action in VendorDetails
                this.getVendorObj(vendor.id);
            }
        }
    }

    /*
    componentDidUpdate(prevProps) {
        console.log("componentDidUpdate vendors")
        // First check if the location has changed
        if (this.props.location !== prevProps.location) {
            console.log("Location changed", this.props.location.state);
            
            // Check for updatedVendor in the state
            if (this.props.location.state && this.props.location.state.updatedVendor) {
                const updatedVendor = this.props.location.state.updatedVendor;
                console.log("Found updatedVendor in new location state", updatedVendor);
                
                // Update component state with new vendor data
                this.setState({ 
                    vendor: updatedVendor 
                }, () => {
                    // Refresh data with the updated vendor
                    this.getPaymentMethods();
                    this.getVendorCounterparty();
                });
            }
            // Also check if there's a new vendor in state but not updatedVendor
            else if (this.props.location.state && 
                    this.props.location.state.vendor && 
                    (!prevProps.location.state || this.props.location.state.vendor !== prevProps.location.state.vendor)) {
                
                const vendor = this.props.location.state.vendor;
                console.log("Found new vendor in location state", vendor);
                
                this.setState({ 
                    vendor: vendor 
                }, () => {
                    this.getPaymentMethods();
                    this.getVendorCounterparty();
                });
            }
        }
    }
    */

    getVendorObj = (id) => {        
        const body = {
            "vendorId": id
        }
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getVendor`, {}, body, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result) {
                    var vendor = data.vendor;
                    this.setState({ vendor: vendor });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getVendor", error, resp);
            }
        })
    }

    scrollToBillTable = () => {
        // Find the bill table container
        const billTableElement = document.getElementById('bills-table');
        
        if (billTableElement) {
            // Give a slight delay to ensure DOM updates
            setTimeout(() => {
                billTableElement.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            }, 100);
        }
    }

    getBBTxns = (recipientId) => {
        this.setState({ loadingPending: true })
        fetchBBHistory({ viewBy: "CP_PAYMENTS", recipientId }, (err, resp) => {
            if (resp) {
                this.setState({ loadingBBTxns: false, bbTxns: normalizeAndSortHistory(resp).normalizedData })
            } else {
                this.setState({ loadingBBTxns: false })
            }
        })
    }

    getPaymentMethods = (options) => {
        options = options || {}
        var { vendor } = this.state
        if (options.vendor) vendor = options.vendor

        if(!vendor.associatedCPObjectId) {
            return; // Payment methods have not been setup
        }
        
        const body = {
            "vendorId": vendor.associatedCPObjectId
        }
        this.setState({ paymentMethodsLoading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getPaymentMethods`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ paymentMethodsLoading: false })
                const data = resp;
                if (data.result) {
                    var paymentMethods = data.paymentMethods || [];
                    // paymentMethods = paymentMethods.filter(pm => (pm.type != "Wire"));
                    this.setState({ transferMethods: paymentMethods });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getPaymentMethods", error, resp)
                ErrorAlert({ description: error.message });
            }
        })
    }

    getVendorCounterparty = (options) => {
        options = options || {}
        var { vendor } = this.state
        if (options.vendor) vendor = options.vendor
        
        const body = {
            "associatedCPObjectId": vendor.associatedCPObjectId
        }
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getVendorCounterparty`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp || {};
                if (data.result) {
                    var counterpartiesObj = data.counterpartiesObj;
                    this.setState({ bbRecipient: counterpartiesObj });
                    this.getBBTxns(counterpartiesObj.id);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getVendorCounterparty", error, resp)
            }
        })
    }

    getPaymentHistory = (options) => {
        options = options || {}
        var { vendor } = this.state
        if (options.vendor) vendor = options.vendor

        const body = {
            "vendorId": vendor.id,
            "fromDate": options.fromDate || getDateInLocalTZ(moment().subtract(1, 'year'), "YYYY-MM-DD"),
            "toDate": options.toDate || getDateInLocalTZ(moment(), "YYYY-MM-DD"),
        }
        this.setState({ paymentHistoryLoading: true })
        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/getPaymentHistory`, {}, body, (err, resp) => {
            try {
                this.setState({ paymentHistoryLoading: false })
                const data = resp;
                if (data.result) {
                    var chartData = data.chartData || [];
                    this.setState({ paymentHistoryChartData: chartData });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getPaymentHistory", error, resp)
                ErrorAlert({ description: error.message });
            }
        })
    }

    viewRecipient = () => {
        console.log("viewRecipient");
        this.props.history.push({
            pathname: '/banking/recipients/details',
            state: { recipient: this.state.bbRecipient }
        })
    }

    deactivateVendor = () => {
        const body = {
            "vendorId": this.state.vendor.id
        }

        this.setState({ deactivateLoading: true })

        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/deactivate`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                this.setState({ deactivateLoading: false })
                const data = resp
                if (data.result) {
                    message.success(`Successfully deactivated!`);
                    this.props.history.goBack();
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ showDeactivateVendor: false })
            }
        })
    }

    getBill = (record) => {
        this.setState({ billLoading: true });
        const { objectId, transaction, type, transactionId } = record;
        
        let body = {
            objectId: (transaction && !objectId) ? transactionId : objectId
        };

        // This validator checks if the id is a UUID or a mongoDB BSON ID
        if (validate(objectId)) body.fetchByPrimaryKey = false
        else body.fetchByPrimaryKey = true

        // console.log('getObjectDetail', validate(objectId), objectId, transaction, type, transactionId, record);
        const typeMapping = {
            'ACH': 'ACH',
            'Wire': 'WIRE_TFER',
            'Check': 'CHECK_DEPOSIT',
            'Internal': 'BOOK_TFER',
            'Card': 'CARD_TXN',
            'CardMemo': 'MEMO_TXN',
            'Instant': 'INSTANT_TFER',
            'Rtp': 'INSTANT_TFER',
            'International': 'INTERNATIONAL_TFER',
        };

        body.viewBy = typeMapping[type];

        // TBD
        var daca = false; // needs to be passed as a prop see PendingTable usage
        // if (daca) body.DacaBusinessId = account?.businessId
        console.log("objData body", body, record.rail);
        apiPOSTReq(`${environment.bbBaseUrl}/${daca ? 'daca' : 'bb'}/getObjectDetail`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                var objData = resp || {};
                console.log("objData", record, objData);
                if (err) throw Error(err);
                if (!resp.result) throw Error(resp.responseMessage || resp.error);

                const objectDetailMapping = {
                    'ACH': 'achTransferObj',
                    'Wire': 'wireTransferObj',
                    'Check': 'checkDepositObj',
                    'Internal': 'bookTransferObj',
                    'Card': 'cardManagementTransactionInfo',
                    'CardMemo': 'cardManagementTransactionInfo',
                    'Instant': 'instantTransferObj',
                    'International': 'internationalTransferObj',
                };

                var objectDetail = objData[objectDetailMapping[type]] || record;

                apiPOSTReq(`${environment.payBaseUrl}/payables/bills/getBill`, { "BankProvider": environment.bankProvider.crb }, { billId: objectDetail.billId }, (err, resp) => {
                    try {
                        const data = resp || {};
                        if (data.result && data.bill) {
                            this.setState({ fullScreenModalContent: <NewBillFlow
                                bill={data.bill}
                                payFlow={false}
                                onClose={() => this.setState({fullScreenModalContent: null})}
                                vendorId={data.bill.vendorId}
                            /> })
                        } else {
                            throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                        }
                    } catch (error) {
                        ErrorAlert({ description: error.message })
                    } finally {
                        this.setState({ billLoading: false });
                    }
                })
            } catch (error) {
                console.log("error.message", error);
                ErrorAlert({ description: "Sorry, we had trouble processing your request. Please try again." });
                this.setState({ billLoading: false });
            }
        })
    }

    saveVendor = (options) => {
        var { attachments } = options;
        var { vendor } = this.state;
        vendor.attachments = attachments;

        const body = {
            "vendor": vendor
        }

        apiPOSTReq(`${environment.payBaseUrl}/payables/vendors/save`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp;
                if (data.result) {
                    this.setState({ vendor: data.vendor });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR /payables/vendors/save", error)
                ErrorAlert({ description: error.message })
            }
        })
    }

    handleBillDetail = (inboxItem) => {
        this.props.history.push({
            pathname: '/payables/inbox/detail',
            state: { inboxItem: inboxItem }
        })
    }
    
    getDocumentsTab = () => {
        var { vendor } = this.state;
        var { theme } = this.props;
        var { attachments } = vendor || {};
        attachments = attachments || [];
        
        const handleDeleteFile = (uri) => {
            const currentAttachments = (vendor.attachments || []).filter(item => item.uri !== uri);
            this.saveVendor({ attachments: currentAttachments });
        };
        
        return (
            <FlexColumn gap='16px'>
                <TableView
                    id="doc-table"
                    titleText='Uploaded Documents'
                    descText='Upload documents such as W-9, purchase orders, or any other relevant files.'
                    tableLayout='auto'
                    loading={this.state.loading}
                    dataSource={attachments}
                    pagination={false}
                    rowKey={(record) => record.uri}
                    ctaContent={
                        <Button
                            solid
                            permtype="Override"
                            onClick={() => this.setState({ showUploadModal: true, uploadDoc: {} })}
                            text='Upload New Document'
                        />
                    }
                    columns={[
                        {
                            title: 'File Name',
                            dataIndex: 'fileName',
                            render: (text) => <Text>{text}</Text>
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            render: (item) => <Tag tagpreset={theme.colors.secondary8}>{item}</Tag>,
                            width: '120px'
                        },
                        {
                            title: 'Note',
                            dataIndex: 'notes',
                            render: (text) => <Text>{text || '-'}</Text>
                        },
                        {
                            title: 'Action',
                            width: "100px",
                            render: (text, item) => (
                                <Flex start centerH gap='4px'>
                                    <SignedLink {...item} viewIcon={<LucideIcon icon={Eye} color={theme.colors.primary2} size={18} />} />
                                    <Popconfirm 
                                        title="Are you sure you want to delete this file?" 
                                        onConfirm={() => handleDeleteFile(item.uri)}
                                    >
                                        <a><LucideIcon icon={Trash} color={theme.colors.primary2} size={18} /></a>
                                    </Popconfirm>
                                </Flex>
                            ),
                            align: "right"
                        }
                    ]}
                />
            </FlexColumn>
        );
    }

    columns = [
        {
            title: 'Name',
            dataIndex: 'nickName',
            key: 'nickName',
            render: (nickName, transferMethod) => <Flex start centerH gap='8px'>
                {renderBankIcon(transferMethod.bankDetail, '24px')}
                <Text weight={500}>{nickName}</Text>
                {
                    (!transferMethod.active) &&
                    <Tag alert>Inactive</Tag>
                }
            </Flex>
        },

        {
            dataIndex: 'type',
            key: 'type',
            align: 'right',
            width: '100px',
            render: (type, transferMethod) => <Flex end gap='8px'>
                <Tag bordered primary>{type}</Tag>
                {
                    transferMethod.bankDetail.accountNumber &&
                    <Tag>{transferMethod.bankDetail.accountNumber && transferMethod.bankDetail.accountNumber.substring(transferMethod.bankDetail.accountNumber.length - 4, transferMethod.bankDetail.accountNumber.length)}</Tag>
                }
            </Flex>
        },
        {
            dataIndex: 'action',
            key: 'action',
            align: 'left',
            width: '50px',
            onHover: true,
            render: (type, transferMethod) => <Flex end centerHorizontally gap='8px'>
                {
                    (transferMethod.active) &&
                    <>
                        <ImageButton src={Edit} onClick={(e) => {
                            this.setState({ showTransferModal: true, editPm: transferMethod, moreDropdownVisible: false })
                            e.stopPropagation()
                        }} />
                        <ImageButton src={Delete} color='#E52D2D' onClick={(e) => {
                            this.setState({ showDeactivateTMModal: true, deactivateTm: transferMethod, moreDropdownVisible: false })
                            e.stopPropagation()
                        }} />
                    </>
                }
            </Flex>
        },
    ]

    render() {
        var { theme, aionStore } = this.props;
        const { vendor, bbTxns, paymentMethodsLoading, loadingBBTxns, selectedRowId, transferMethods, showDeactivateTMModal, deactivateTm, showTransferModal, paymentHistoryChartData, paymentHistoryLoading, fullScreenModalContent, showDeactivateVendor, deactivateLoading, billLoading, bbRecipient } = this.state;

        var { 
            vendorName, active, primaryEmail, primaryPhone, taxId, address, type, customerId, billRecipientEmail,
            outstandingBalance, totalPaidAmount, averageBillAmt, mostCommonCategory, highestBillAmount, unpaidBillsCount, overdueBillsCount
         } = vendor;

        const recipientsPerm = getResourcePerm("BusinessBanking.Recipients");

        return (
            <FlexColumn className='main-padding' style={{ width: '100%', marginBottom: '48px' }} start>
                <PageHeader
                    titleText={vendorName}
                    back
                    marginBottom='24px'
                />

                <Tabs size="large">
                    <TabPane tab="Overview" key="Details" style={{ marginTop: 12 }}>
                        <FlexColumn start gap='24px'>
                            <Flex start fullWidth gap='24px' style={{ height: '300px' }}>
                                <CardContainer fullHeight style={{ width: '400px' }}>
                                    <FlexColumn gap='24px'>
                                        <Flex between centerHorizontally gap='24px'>
                                            <Text margin='0' weight={500} size='18px' color={theme.colors.primary2}>Overview</Text>
                                        </Flex>

                                        <Flex between wrap gap='16px'>
                                            <LabeledInput width='160px' nomargin label='Current Balance' type='read-only' value={`$${toCurrency(outstandingBalance)}`} />
                                            <LabeledInput width='160px' nomargin label='Payments to Date' type='read-only' value={`$${toCurrency(totalPaidAmount)}`} />

                                            <LabeledInput width='160px' nomargin label='Average Bill' type='read-only' value={`$${toCurrency(averageBillAmt)}`} />
                                            <LabeledInput width='160px' nomargin label='Largest Bill' type='read-only' value={`$${toCurrency(highestBillAmount)}`} />
                                            {/* <LabeledInput width='160px' nomargin label='Common Category' type='read-only' value={mostCommonCategory || "--"} /> */}

                                            <LabeledInput 
                                                width='160px' 
                                                nomargin 
                                                label='Outstanding Bills' 
                                                type='read-only' 
                                                value={
                                                    <Flex start centerH gap='4px'>
                                                        <a onClick={() => {
                                                            this.setState({ billPresetFilter: 'outstandingBills' }, () => {
                                                                this.scrollToBillTable();
                                                            });
                                                        }}>{unpaidBillsCount} unpaid</a> 
                                                        <a onClick={() => {
                                                            this.setState({ billPresetFilter: 'overdueBills' }, () => {
                                                                this.scrollToBillTable();
                                                            });
                                                        }}>({overdueBillsCount} overdue)</a>
                                                    </Flex>
                                                } 
                                            />
                                        </Flex>
                                    </FlexColumn>
                                </CardContainer>

                                <CardContainer fullHeight grow>
                                    <PaymentHistoryChart 
                                        vendorId={this.state.vendor.id} 
                                        height={250} 
                                        chartTitle={'Payment History'}  
                                    />
                                </CardContainer>
                            </Flex>
                            
                            {/* Inbox Table */}
                            <InboxTable
                                vendorId={this.state.vendor.id}
                                selectedTab="New"
                                hideVendorColumn={true}
                                title={`Inbox`}
                                description={`Mail from ${this.state.vendor.vendorName} sent to your inbox`}
                                customPlaceholder="Search by Subject"
                                history={this.props.history}
                                onBillSelect={(inboxItem) => this.handleBillDetail(inboxItem)}
                                hideOnEmpty
                            />

                            {/* Bills Table */}
                            <FlexColumn>
                                <BillTable
                                    id="bills-table"
                                    vendorId={this.state.vendor.id}
                                    activeTab="All"
                                    hideVendorColumn={true}
                                    titleText={`Bills`}
                                    descText={`All bills from ${this.state.vendor.vendorName}`}
                                    deleteBill={(bill) => this.setState({ billToDelete: bill, showDelete: true })}
                                    handleRescheduleBill={this.handleRescheduleBill}
                                    cancelBillPayment={(bill) => this.setState({ billToCancel: bill, showCancel: true })}
                                    enableFiltering
                                    pagination={{
                                        current: 1,
                                        pageSize: 10,
                                        total: 0
                                    }}
                                    presetFilter={this.state.billPresetFilter}
                                    onFilterChange={(filters) => {
                                        // Reset preset filter after it's applied
                                        this.setState({ billPresetFilter: null });
                                    }}
                                />
                            </FlexColumn>
                        </FlexColumn>
                    </TabPane>

                    <TabPane tab="Details" key="BankDetails" style={{ marginTop: 12 }}>
                        <FlexColumn start gap='24px'>
                            <CardContainer fullHeight >
                                <FlexColumn gap='8px'>
                                    <Flex between gap='24px'>
                                        <Text margin='0' weight={500} size='18px' color={theme.colors.primary2}>Vendor details</Text>
                                        {
                                            active ?
                                                <Flex between centerHorizontally gap='4px'>
                                                    <ImageButton
                                                        src={Edit}
                                                        onClick={() => {
                                                            this.props.history.push({
                                                                pathname: '/payables/vendors/edit',
                                                                state: { vendor }
                                                            })
                                                        }}
                                                    />
                                                    <ImageButton src={Delete} onClick={() => this.setState({ showDeactivateVendor: true })} />
                                                </Flex>
                                                :
                                                <></>
                                        }
                                    </Flex>
                                    
                                    <Flex start gap='24px'>
                                        <Flex between wrap gap='24px'>
                                            <LabeledInput nomargin label='Type' type='read-only' value={type || "--"} />
                                            <LabeledInput nomargin label='Email' type='read-only' value={primaryEmail || "--"} />
                                            <LabeledInput nomargin label='Address' type='read-only' value={addressObjectToStr(address) || "--"} />
                                        </Flex>
                                        <Flex between wrap gap='24px'>
                                            <LabeledInput nomargin label='Phone' type='read-only' value={primaryPhone ? formatPhoneNumber(primaryPhone) : "--"} />
                                            <LabeledInput nomargin label='Tax ID' type='read-only' value={taxId || "--"} />
                                            <LabeledInput nomargin label='Customer ID' type='read-only' value={customerId || "--"} />
                                        </Flex>
                                    </Flex>
                                </FlexColumn>
                            </CardContainer>
                            <FlexColumn>
                                {
                                    vendor.associatedCPObjectId &&
                                    <ContainerBanner
                                        style={{padding: '10px 12px 16px'}}
                                    >
                                        <Flex start centerH gap='8px'>
                                            <Text
                                                color={theme.body}
                                            >
                                                Payment methods are shared with banking recipients. Any changes made will update the recipient's payment methods as well.
                                            </Text>
                                            {
                                                recipientsPerm && vendor.associatedCPObjectId &&
                                                <TextButton text='VIEW RECIPIENT' color={theme.colors.primary4} onClick={() => this.viewRecipient()} />
                                            }
                                        </Flex>
                                        
                                    </ContainerBanner>
                                }
                                <TableWrapper>
                                    <TableView
                                        id="transfer-methods"
                                        titleText="Bank details"
                                        descText={`Bank details for this vendor`}
                                        className='borderless-table'
                                        tableLayout='auto'
                                        columns={this.columns}
                                        dataSource={transferMethods.sort((a, b) => b.active - a.active)}
                                        rowKey='id'
                                        pagination={false}
                                        expand
                                        expandedRowKey={selectedRowId}
                                        getRowDetails={(record) => <PaymentMethodDetails record={{ ...record, vendor: vendor }} />}
                                        onRow={
                                            (record, rowIndex) => {
                                                return {
                                                    onClick: e => {
                                                        if (record.id == selectedRowId) {
                                                            this.setState({ selectedRowId: null })
                                                        } else {
                                                            this.setState({ selectedRowId: record.id })
                                                        }
                                                    }, // click row
                                                }
                                            }
                                        }
                                        ctaContent={
                                            active &&
                                            <Button solid uppercase loading={paymentMethodsLoading} onClick={() => this.setState({ showTransferModal: true })} text={'Add Transfer Method'.toUpperCase()} />
                                        }
                                    />
                                </TableWrapper>
                            </FlexColumn>
                            
                        </FlexColumn>
                    </TabPane>

                    {
                        <TabPane tab="Payment Activity" key="Activity" style={{ marginTop: 12 }}>
                            <FlexColumn start gap='24px'>
                                <PendingTable
                                    title={`Transactions`}
                                    subtitle={`All transfers made to ${vendorName} from Aion including unsuccessful ones. This does not include any bill payment transactions initiated or recorded externally.`}
                                    loadingPending={loadingBBTxns}
                                    pendingTransfers={bbTxns}
                                    collapsible={false}
                                    onCancelled={() => {
                                        this.getBBTxns(bbRecipient.id);
                                    }}
                                    setFullScreenModalContent={(fullScreenModalContent) => this.setState({ fullScreenModalContent })}
                                    reFetchTransactions={() => {
                                        this.getBBTxns(bbRecipient.id);
                                    }}
                                    customColumns={[{
                                        title: '',
                                        dataIndex: 'objectId',
                                        key: 'Account',
                                        align: "right",
                                        onHover: true,
                                        render: (objectId, record) => {
                                            return (
                                                    <TextButton
                                                    text='View Bill' 
                                                    loading={billLoading} 
                                                    onClick={(e) => {
                                                        this.getBill(record);
                                                        e.stopPropagation();
                                                    }} 
                                                    rightIcon={<Image src={RightArrow} />} 
                                                />
                                            )
                                        },
                                        width: 100,
                                    }]}
                                />
                            </FlexColumn>
                        </TabPane>
                    }

                    <TabPane tab="Documents" key="Documents" style={{ marginTop: 12 }}>
                        {this.getDocumentsTab()}
                    </TabPane>
                </Tabs>

                <Modal
                    visible={showDeactivateTMModal}
                    footer={null}
                    closable={false}
                    width={456}
                    destroyOnClose={true}
                    onCancel={() => {
                        this.setState({ showDeactivateTMModal: false })
                    }}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <DeactivateTransferMethod
                        transferMethod={deactivateTm}
                        onCancel={() => this.setState({ showDeactivateTMModal: false })}
                        onDeactivated={() => {
                            this.setState({ showDeactivateTMModal: false, loading: true })
                            this.getPaymentMethods()
                        }} />
                </Modal>

                <Modal
                    visible={showTransferModal}
                    width={616}
                    closable={true}
                    maskClosable={true}
                    style={{ borderRadius: '8px !important' }}
                    footer={null}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showTransferModal: false, transferType: null, editPm: null })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <AddPaymentMethod
                        pm={this.state.editPm}
                        vendor={vendor}
                        onSave={(updatedVendor) => {
                            this.setState({ showTransferModal: false, vendor: updatedVendor }, this.getPaymentMethods({ vendor: updatedVendor }))
                        }}
                    />
                </Modal>
                {
                    fullScreenModalContent &&
                    <FullScreenModal
                        onClick={() => { }}
                        content={fullScreenModalContent}
                        onClose={() => this.setState({ fullScreenModalContent: null })}
                    />
                }
                <AlertModal
                    deactivate
                    visible={showDeactivateVendor}
                    loading={deactivateLoading}
                    title='Deactivate this vendor?'
                    description="Are you sure you want to deactivate this vendor?"
                    descWidth={'350px'}
                    buttonTitle='DEACTIVATE'
                    cancelButtonText='CANCEL'
                    onConfirm={() => {
                        this.deactivateVendor()
                    }}
                    onCancel={() => this.setState({ showDeactivateVendor: false })}
                />
                <DocumentUploadModal
                    key={(this.state.vendor.attachments || []).length + 1}
                    visible={this.state.showUploadModal}
                    onClose={() => this.setState({ showUploadModal: false })}
                    onSave={(uploadedFile) => {
                        
                        // Ensure all required fields are present
                        if (!uploadedFile.fileName || !uploadedFile.type || !uploadedFile.uri) {
                            ErrorAlert({ description: "Missing required attachment information" });
                            return;
                        }
                        
                        // Create a copy of the current attachments or initialize an empty array
                        const currentAttachments = [...(this.state.vendor.attachments || [])];
                        
                        // Check if this is an update of an existing attachment
                        const existingIndex = currentAttachments.findIndex(
                            att => att.uri === uploadedFile.uri || att.type === uploadedFile.type
                        );
                        
                        if (existingIndex >= 0) {
                            // Update existing attachment
                            currentAttachments[existingIndex] = uploadedFile;
                        } else {
                            // Add new attachment
                            currentAttachments.push(uploadedFile);
                        }
                        this.setState({
                            showUploadModal: false
                        });
                        // Update vendor state with the new attachments array
                        this.saveVendor({ attachments: currentAttachments });
                    }}
                    doc={this.state.uploadDoc || {}}
                    businessKey={this.props.aionStore.BusinessUniqueKey}
                    jwt={this.props.aionStore.jwt}
                />
            </FlexColumn>
        )
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(VendorDetails));